<template>
  <div>
    <el-dialog
      v-if="info"
      title="上传协议"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="60%"
      class="editDialog"
      center
    >
      <div class="editDialog-cnt">
        <el-form
          class="demo-addForm"
          label-width="200px"
          ref="refCityForm"
          :model="addForm"
          :rules="cityRules"
        >
          <el-form-item label="上传协议" prop="pact_url">
            <el-upload
              action="#"
              v-loading="uploadLoading"
              :on-preview="onHandlePictureCardPreview"
              :class="{ hide: pact_url.length || !pact_url }"
              :file-list="pact_url"
              list-type="picture-card"
              :http-request="(data) => onHandleUploadFile(data, 'pact_url')"
              :before-remove="() => onHandleDeleteFile('pact_url')"
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">关闭</el-button>
        <el-button type="primary" :loading="submitLoading" @click="qr"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postGetIdcardInfo } from "@/api/general/manager.js";

export default {
  name: "editDialog",
  props: {},
  data() {
    return {
      token: sessionStorage.getItem("token"),
      httpurl: process.env.VUE_APP_GENERAL_URL + "/uploadBusinessLicense",
      dialogVisible: false,
      info: "",
      uploadLoading: false,
      submitLoading: false,
      addForm: {
        id: "", //	T文本	是	供应商id
        pact_url: "", //	T文本	是	认证类型
      },

      pact_url: [], // 变更协议
      // 表单校验
      cityRules: {
        pact_url: [
          {
            required: true,
            message: "请上协议图片",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 删除图片
     */
    onHandleDeleteFile(name) {
      this[name] = [];
      this.addForm[name] = "";
      this.$refs.refCityForm.validateField(name);
    },
    /**
     * 上传图片
     */
    onHandleUploadFile(options, name) {
      this.uploadLoading = true;
      // 拿到 file
      let file = options.file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // console.log(e.target.result);
        this.ajaxUploadImage(e.target.result, name, options.file.uid);
      };
    },
    /**
     * 图片路径请求
     */
    async ajaxUploadImage(img, name, uid) {
      try {
        const res = await this.$api.general.uploadImage({ file_data: img });
        // 增加uid 赋值 解决上传图片跳动问题
        this[name] = [{ url: res.data, uid }];

        this.addForm[name] = res.data;

        this.$refs.refCityForm.validateField(name);
      } catch (err) {
      } finally {
        this.uploadLoading = false;
      }
    },

    /**
     * 预览上传图片
     */
    onHandlePictureCardPreview(file) {
      const params = {
        bigImage: file.url,
        showImage: true,
      };
      this.$emit("on-show-image", params);
    },

    /**
     * 初始化
     */
    onInitData(data) {
      this.info = data;
      //    this.idcard_a= [] // 身份证国徽图片
      //   this.idcard_b=[] // 身份证人像图片
        this.pact_url= [] // 变更协议
      this.dialogVisible = true;
      this.addForm = {
        id: data.id,
        pact_url: "",
      };
    },
    qr() {
      console.log(this.addForm, "this.cityForm==");
      this.$refs.refCityForm.validate(async (valid) => {
        console.log(valid, "1valid11");
        if (!valid) {
          return;
        }
        let obj = JSON.parse(JSON.stringify(this.addForm));

        this.submitLoading = true;

        this.$api.general
          .supplierpacturl({
            ...obj,
          })
          .then((res) => {
            this.$emit("on-change", true);
            this.onHandleClose();
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.submitLoading = false;
          })
          .catch((err) => {
            this.submitLoading = false;
          });

        // try {
        //   const res = await certifylogistics(obj);
        //   console.log(res, "res==");

        //   this.dialogVisible = false;
        //   this.$message({
        //     message: "城市仓主体认证成功",
        //     type: "success",
        //   });
        //   this.$emit("on-refresh-list");
        // } catch (error) {
        //   console.log(error, "certifylogistics");
        // } finally {

        // }
      });
    },

    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.editDialog {
  .editDialog-cnt {
    // height: 500px;
    overflow-y: auto;
    padding-right: 40px;
    box-sizing: border-box;
  }
  .list-item {
    display: flex;
    align-items: center;

    .list-item-left {
      font-size: 24px;
      color: #000;
    }
    .list-item-right {
      font-size: 24px;
      .el-image {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
